export const avatarColors = [
    { bg: "#DCFCE7", text: "#15803D" }, // Green
    { bg: "#DBEAFE", text: "#2563EB" }, // Blue
    { bg: "#CCFBF1", text: "#0F766E" }, // Teal
    { bg: "#FEF3C7", text: "#D97706" }, // Yellow
    { bg: "#E0E7FF", text: "#2563EB" }, // Indigo
    { bg: "#FCE7F3", text: "#DB2777" }, // Pink
    { bg: "#F3E8FF", text: "#9333EA" }, // Purple
    { bg: "#FFEDD5", text: "#EA580C" }, // Orange
  ];
